import { useMemo } from "react";
import { useChosenDepartment } from "../contexts/ChosenDepartment";
import type { Job } from "../utils/models";
import { useDepartmentById } from "./useDepartmentById";
import { getEnabledJobs, useAllJobs } from "./useJobs";

/**
 * The jobs enabled for a department by id — the drilled one when Management Center runs in the ops backoffice. The
 * server sends job objects only for the current department; any other carries just its `jobIds`, so those are matched
 * against the global jobs catalog.
 */
export function useDepartmentJobs(departmentId: string): Job[] {
	const { chosenDepartment } = useChosenDepartment();
	const department = useDepartmentById(departmentId);
	const isChosenDepartment = departmentId === chosenDepartment.department_id;
	const { data: catalog } = useAllJobs(!isChosenDepartment);

	return useMemo(() => {
		// DEFAULT: no job options for a department the user's list lacks; useDepartmentById tracks it.
		if (!department) return [];
		return getEnabledJobs(isChosenDepartment ? department : { jobIds: department.jobIds, jobs: catalog });
	}, [department, isChosenDepartment, catalog]);
}
